import { restApi } from '../../../../services/Api'

function createEagle(solicitacaoId) {
  return restApi.post(`/solicitacoes/${solicitacaoId}/eagle`)
}

function getEagle(solicitacaoId) {
  return restApi.get(`/solicitacoes/${solicitacaoId}/eagle`)
}

function refreshResultadoEagle(solicitacaoId) {
  return restApi.get(`/solicitacoes/${solicitacaoId}/eagle/refresh`)
}

function recreateEagle(solicitacaoId) {
  return restApi.post(`/solicitacoes/${solicitacaoId}/eagle/recreate`)
}

function recreateEagleNewConsult(solicitacaoId) {
  return restApi.post(`/solicitacoes/${solicitacaoId}/eagle/recreate/new`)
}

const eagleRepository = {
  create: createEagle,
  fetch: getEagle,
  refreshResult: refreshResultadoEagle,
  recreate: recreateEagle,
  recreateNewConsult: recreateEagleNewConsult
}

export default eagleRepository
